import { FC, useEffect, useState } from "react"
import { ProgressIndicator, Spinner } from "../../widgets"

import { IReadOptions } from "../../services/models"
import clsx from "clsx"
import { toAbsoluteUrl } from "../../../helpers"
import { useAuth } from "../../../modules/auth"
import { useLazyReadQuery } from "../../services/data/tableDataApi"
import { useParams } from "react-router-dom"

interface IContactCardProps {
    contactId: string,
    className?: string,
    loadingContactId: string
}

export const ContactCard: FC<IContactCardProps> = ({
    contactId,
    className,
    loadingContactId
}) => {
    const { user } = useAuth()
    const { siteId } = useParams()

    const [readContact, { isLoading }] = useLazyReadQuery()
    const [contact, setContact] = useState<{ fullName: string, rollNumber: string, entityImage?: string }>()

    useEffect(() => {
        if (!siteId) return

        const options: IReadOptions = {
            portalId: siteId,
            userId: user?.userId || '',
            tableId: "18",
            sysId: contactId,
            fieldList: ["Name", "AXT Roll No.", "entityimage"]
        }

        readContact(options)
            .unwrap()
            .then((result) => {
                setContact({
                    fullName: result["Name"],
                    rollNumber: result["AXT Roll No."],
                    entityImage: result["entityimage"]
                })
            })
            .catch((error) => {
                console.log(error)
            })
        // eslint-disable-next-line
    }, [contactId])


    if (isLoading)
        return <Spinner />

    if (!contact)
        return <></>

    return <div className={clsx(className, "card")}>
        <div className="card-body">
            {(!!contact.entityImage) ? <>
                <img alt='Logo' className="rounded-circle mh-100px" src={`data:image/png;base64, ${contact.entityImage}`} />
            </> : <>
                <img alt='Logo' className="rounded-circle mh-100px" src={toAbsoluteUrl('/media/avatars/blank.png')} />
            </>}
        </div>
        <div className="card-body">
            <div className="d-flex gap-3 flex-column">
                {loadingContactId === contactId && <ProgressIndicator show={true} />}
                <div>
                    <label className="fs-4">{contact?.fullName}</label>
                </div>
                <div className="d-flex gap-3">
                    <label>Roll Number</label>
                    <p>{contact?.rollNumber}</p>
                </div>
            </div>
        </div>
    </div>
}